import React, { useEffect } from "react";
import Grid from "../../assets/Grid.png";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
    const script = document.createElement("script");
    script.type = "module";
    script.src = "/off_seo.js";
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <div className="full-container" >
        <section className="privacy-section d-flex flex-colummn text-center w-100" style={{padding: '10rem'}}>
          <p className="privacy-subtitle" style={{ fontSize: "24px" }}>
            Packky (powered by Chaafo)
          </p>
          <h2 className="privacy-title1" style={{ fontSize: "24px" }}>
            PRIVACY POLICY
          </h2>
        </section>
        <section
          className="privacy-container-fluid"
          style={{
            backgroundColor: "#ffeef8",
            backgroundImage: `url(${Grid})`,
          }}
        >
          <div className="privacy-card bg-white">
            <h6 className="privacy-title"> Introduction :</h6>
            <div className="mt-4">
              <div className="d-flex mb-3">
                <div className="fw-bold me-2" style={{ minWidth: "15px" }}>
                  1.
                </div>
                <div className="fw-normal privacy-title3" style={{ color: " #525252" }}>
                  This Privacy Policy explains how Packky (powered by Chaafo) (https://) collects,
                  uses, stores, shares, and processes the personal data Packky (powered by Chaafo)
                  gathers when you are on our sites and using our apps that
                  refer to or link to the Privacy Policy.
                </div>
              </div>
              <div className="d-flex mb-3">
                <div className="fw-bold me-2" style={{ minWidth: "15px" }}>
                  2.
                </div>
                <div
                  className="fw-normal privacy-title3"
                  style={{ color: " #6b6b6b", maxWidth: "50rem" }}
                >
                  This Privacy Policy will take effect from the date indicated
                  above. We may, at a future time, amend the Privacy Policy. If
                  we do amend the Privacy Policy, we shall post the updated
                  Privacy Policy on this page (or a linked page) and change the
                  date at the beginning of this page. We invite you to return to
                  this date when you are on our website to seek changes and
                  revisions to this Privacy Policy. Your access to or use of the
                  site or our Services after changes have been posted to this
                  Privacy Policy (and not earlier, if changes have been made)
                  will be considered your acceptance of the changes.
                </div>
              </div>
            </div>
            <h6 className="privacy-title" style={{ color: " #525252" }}>
              {" "}
              Who we are :
            </h6>
            <div className="mt-4">
              <div className="d-flex mb-3">
                <div className="fw-bold me-2" style={{ minWidth: "20px" }}>
                  1.
                </div>
                <div
                  className="fw-normal privacy-title3"
                  style={{ color: " #6b6b6b", maxWidth: "51rem" }}
                >
                  At Packky (powered by Chaafo), we are the only delivery service provider that is
                  dedicated to bridging Restaurants and customers with reliable
                  delivery partners. Our system allows independent contractors
                  to effectively deliver services and products to customers
                  while guaranteeing on-time and consistent delivery
                  experiences. We aim to provide flexibility and independence
                  for our delivery partners as well as give businesses and
                  individuals exceptional service.
                </div>
              </div>
              <div className="d-flex mb-3">
                <div className="fw-bold me-2" style={{ minWidth: "15px" }}>
                  2.
                </div>
                <div
                  className="fw-normal privacy-title3"
                  style={{ color: " #6b6b6b", maxWidth: "51rem" }}
                >
                  Our goal is to create a strong, user-centric ecosystem that
                  enables delivery partners to succeed while providing excellent
                  service to our customers. Through the use of cutting-edge
                  technology, data analysis, and a committed team, we will
                  strive to constantly improve the delivery process and lead
                  innovation in the logistics sector.
                </div>
              </div>
              <div className="d-flex mb-3">
                <div className="fw-bold me-2" style={{ minWidth: "15px" }}>
                  3.
                </div>
                <div
                  className="fw-normal privacy-title3"
                  style={{ color: " #6b6b6b", maxWidth: "52rem" }}
                >
                  Whether you are a delivery partner wanting to become part of
                  our network or a customer requiring secure delivery services,
                  Packky (powered by Chaafo) is here to offer a smooth and efficient experience for
                  everyone.
                </div>
              </div>
            </div>
            <h6 className="privacy-title" style={{ color: " #525252" }}>
              {" "}
              Purpose of Data Processing :
            </h6>

            <div className="d-flex mb-3">
              <div
                className="fw-normal privacy-title3">
                So that we can collect all data from our delivery partners,
                Drivers, and Customers when they register to use our Services
                and during the provision of those Services. We also gather
                personal information from various groups of individuals,
                including prospective and past Drivers and Customers, other
                companies and persons who could be related or associated with
                them, visitors to our premises, and other persons who could
                interact with us in the course of carrying out our business. The
                collection of such information is aimed at ensuring and
                improving the delivery of the Services to our Drivers and
                Customers.
              </div>
            </div>
            <h6 className="privacy-title" style={{ color: " #525252" }}>
              {" "}
              Information We Collect :
            </h6>
            <p className="privacy-title" style={{ color: " #525252" }}>
              {" "}
              We gather the following categories of information:
            </p>

            <h6
              className="privacy-title2 fw-semibold"
              style={{ color: " #525252" }}
            >
              {" "}
              Personal Information:
              <span
                className=" fw-normal privacy-title3"
                style={{ color: " #6b6b6b" }}
              >
                {" "}
                When you sign up as a delivery partner, we obtain your name,
                contact information (phone number and email address), delivery
                preferences, and payment information.
              </span>
            </h6>
            <h6
              className="privacy-title2 fw-semibold"
              style={{ color: " #525252" }}
            >
              {" "}
              Location Data:
              <span className="fw-normal privacy-title3" style={{ color: " #6b6b6b" }}>
                {" "}
                To facilitate deliveries, we may collect your real-time location
                information through the website or mobile app when you accept
                delivery requests.
              </span>
            </h6>
            <h6 className="privacy-title2 fw-semibold" style={{ color: " #525252" }}>
              {" "}
              Device Information:
              <span className="fw-normal privacy-title3" style={{ color: " #6b6b6b" }}>
                {" "}
                We may collect information about the device you use to access
                our website, such as your IP address, browser type, device
                identifiers, and usage data.
              </span>
            </h6>
            <h6 className="privacy-title2 fw-semibold" style={{ color: " #525252" }}>
              {" "}
              Transaction Data:
              <span className="fw-normal privacy-title3" style={{ color: " #6b6b6b" }}>
                {" "}
                We collect information related to the deliveries you complete,
                including delivery history, earnings, and payment transactions.
              </span>
            </h6>
            <h6 className="privacy-title" style={{ color: " #525252" }}>
              {" "}
              Driver personal data collected:
            </h6>
            <h6 className="privacy-title2 fw-semibold" style={{ color: " #525252" }}>
              {" "}
              Identification and Contact Information such as
            </h6>
            <h6 className="privacy-title2 fw-semibold" style={{ color: " #525252" }}>
              {" "}
              Full Name:
              <span className="fw-normal privacy-title3" style={{ color: " #6b6b6b" }}>
                {" "}
                To identify you as a delivery partner and ensure proper records.
              </span>
            </h6>
            <h6 className="privacy-title2 fw-semibold" style={{ color: " #525252" }}>
              {" "}
              Email Address:
              <span className="fw-normal privacy-title3" style={{ color: " #6b6b6b" }}>
                {" "}
                To communicate important updates, service notifications, and
                support requests.
              </span>
            </h6>
            <h6 className="privacy-title2 fw-semibold" style={{ color: " #525252" }}>
              {" "}
              Phone Number:
              <span className="fw-normal privacy-title3" style={{ color: " #6b6b6b" }}>
                {" "}
                To contact you regarding deliveries, urgent updates, or customer
                service needs.
              </span>
            </h6>
            <h6 className="privacy-title2 fw-bold" style={{ color: " #525252" }}>
              {" "}
              Profile Picture:
              <span className="fw-normal privacy-title3" style={{ color: " #6b6b6b" }}>
                {" "}
                A photo for identification purposes on the platform.
              </span>
            </h6>
            <h6 className="privacy-title mt-4" style={{ color: " #525252" }}>
              {" "}
              Location Data
            </h6>
            <h6 className="privacy-title2 fw-semibold" style={{ color: " #525252" }}>
              {" "}
              Real-Time Location:
              <span className="fw-normal privacy-title3" style={{ color: " #6b6b6b" }}>
                {" "}
                To assign and track deliveries, optimize routes, and ensure
                timely delivery. This data may be collected through GPS or other
                tracking technologies while you are using the platform.
              </span>
            </h6>
            <h6 className="privacy-title2 fw-semibold" style={{ color: " #525252" }}>
              {" "}
              Delivery Route Information:
              <span className="fw-normal privacy-title3" style={{ color: " #6b6b6b" }}>
                {" "}
                Information about the routes you take for deliveries may also be
                collected for logistical purposes and efficiency improvement.
              </span>
            </h6>
            <h6 className="privacy-title2 fw-semibold " style={{ color: " #525252" }}>
              {" "}
              Driver’s License and Identification Documents:
            </h6>
            <h6 className="privacy-title2 fw-semibold" style={{ color: " #525252" }}>
              {" "}
              Driver’s License Number:
              <span className="fw-normal privacy-title3" style={{ color: " #6b6b6b" }}>
                {" "}
                To verify that you have a valid driver’s license and are legally
                allowed to drive.
              </span>
            </h6>
            <h6 className="privacy-title2 fw-semibold" style={{ color: " #525252" }}>
              {" "}
              Government-Issued ID:
              <span className="fw-normal privacy-title3" style={{ color: " #6b6b6b" }}>
                {" "}
                For age verification and additional identity checks to ensure
                you meet platform requirements and local regulations.
              </span>
            </h6>
            <h6 className="privacy-title " style={{ color: " #525252" }}>
              {" "}
              Vehicle Information:
            </h6>
            <h6 className="privacy-title2 fw-semibold" style={{ color: " #525252" }}>
              {" "}
              Vehicle Type and License Plate Number:
              <span className="fw-normal privacy-title3" style={{ color: " #6b6b6b" }}>
                {" "}
                To verify the vehicle you will be using for deliveries and
                ensure it meets company and legal standards.
              </span>
            </h6>
            <h6 className="privacy-title2 fw-semibold" style={{ color: " #525252" }}>
              {" "}
              Insurance Details:
              <span className="fw-normal privacy-title3" style={{ color: " #6b6b6b" }}>
                {" "}
                Information related to your vehicle’s insurance coverage, if
                applicable, to ensure compliance with local laws and platform
                requirements.
              </span>
            </h6>
            <h6 className="privacy-title" style={{ color: " #525252" }}>
              {" "}
              Background Check Information:
            </h6>
            <h6 className="privacy-title2 fw-semibold" style={{ color: " #525252" }}>
              {" "}
              Criminal History (if applicable):
              <span className="fw-normal privacy-title3" style={{ color: " #6b6b6b" }}>
                {" "}
                For security and safety purposes, we may conduct background
                checks (subject to local regulations) to verify your suitability
                as a delivery partner.
              </span>
            </h6>
            <h6 className="privacy-title2 fw-semibold" style={{ color: " #525252" }}>
              {" "}
              Driving History:
              <span className="fw-normal privacy-title3" style={{ color: " #6b6b6b" }}>
                {" "}
                To verify your driving record and ensure that you are a
                responsible driver with a safe history.
              </span>
            </h6>
            <h6 className="privacy-title" style={{ color: " #525252" }}>
              {" "}
              Customer personal data collected:
            </h6>
            <p className="fw-normal privacy-title3" style={{ color: " #525252" }}>
              We obtain the following personal data from Customers (individuals
              and businesses), which includes but is not limited to.
            </p>
            <p className="fw-normal privacy-title3" style={{ color: " #525252" }}>
              Customer information including; full name, address, telephone
              number, company name (optional), email address.
            </p>
            <p className="fw-normal privacy-title3" style={{ color: " #525252" }}>
              Pick-up details for each Job Request, including; sender name,
              contact telephone number, pick-up address, what3words (optional),
              pick-up date and time, duration of hire (if applicable), whether
              they need assistance with loading/unloading item.
            </p>
            <p className="fw-normal privacy-title3" style={{ color: " #525252" }}>
              Drop-off details for each Job Request, including; recipient name,
              contact telephone number, drop-off address, drop-off date and
              time.
            </p>
            <p className="fw-normal privacy-title3" style={{ color: " #525252" }}>
              Drop-off items including; package size, weight and quantity and
              whether they need help/two man assistance with loading/unloading
              items, cost of goods.
            </p>
            <h6 className="privacy-title2 fw-semibold" style={{ color: " #525252" }}>
              {" "}
              How We Use Your Information :
              <span className="fw-normal privacy-title3" style={{ color: " #6b6b6b" }}>
                {" "}
                We use your information for the following purposes
              </span>
            </h6>

            <h6 className="privacy-title2 fw-semibold" style={{ color: " #525252" }}>
              {" "}
              Use of Location Data:
              <span className="fw-normal privacy-title3" style={{ color: " #6b6b6b" }}>
                {" "}
                We collect location data in the background to support delivery
                tracking for registered drivers. This data is not shared with
                third parties and is only used for operational purposes. where
                this line add in privacy policy page.
              </span>
            </h6>

            <h6 className="privacy-title2 fw-semibold" style={{ color: " #525252" }}>
              {" "}
              To Provide Services:
              <span className="fw-normal privacy-title3" style={{ color: " #6b6b6b" }}>
                {" "}
                We use your personal information to enable your participation as
                a delivery partner, including matching you with delivery
                requests, processing payments, and communicating with you about
                delivery-related matters.
              </span>
            </h6>
            <h6 className="privacy-title2 fw-semibold" style={{ color: " #525252" }}>
              {" "}
              To Improve Our Services:
              <span className="fw-normal privacy-title3" style={{ color: " #6b6b6b" }}>
                {" "}
                We may analyze usage data to improve the website’s
                functionality, enhance user experience, and optimize delivery
                operations.
              </span>
            </h6>
            <h6 className="privacy-title2 fw-semibold" style={{ color: " #525252" }}>
              {" "}
              To Communicate with You:
              <span className="fw-normal privacy-title3" style={{ color: " #6b6b6b" }}>
                {" "}
                We may send you updates, notifications, and promotional
                materials about our services. You can opt out of receiving
                marketing communications at any time.
              </span>
            </h6>
            <h6 className="privacy-title2 fw-semibold" style={{ color: " #525252" }}>
              {" "}
              Legal Compliance:
              <span className="fw-normal privacy-title3" style={{ color: " #6b6b6b" }}>
                {" "}
                We process personal and transactional data to comply with
                applicable laws and regulations, including tax obligations, data
                protection laws, and labor laws.
              </span>
            </h6>
            <h6 className="privacy-title2 fw-semibold" style={{ color: " #525252" }}>
              {" "}
              Sharing Your Information:
              <span className="fw-normal privacy-title3" style={{ color: " #6b6b6b" }}>
                {" "}
                We do not sell your personal information. However, we may share
                your information in the following situations:
              </span>
            </h6>
            <h6 className="privacy-title2 fw-semibold" style={{ color: " #525252" }}>
              {" "}
              With Service Providers:
              <span className="fw-normal privacy-title3" style={{ color: " #6b6b6b" }}>
                {" "}
                We may share your data with trusted third-party service
                providers who assist us in operating our website and providing
                services (e.g., payment processors, data storage providers).
              </span>
            </h6>
            <h6 className="privacy-title2 fw-semibold" style={{ color: " #525252" }}>
              {" "}
              For Legal Reasons:
              <span className="fw-normal privacy-title3" style={{ color: " #6b6b6b" }}>
                {" "}
                We may disclose your information if required to do so by law, to
                enforce our terms of service, or to protect the rights,
                property, or safety of the website, our users, or others.
              </span>
            </h6>
            <h6 className="privacy-title2 fw-semibold" style={{ color: " #525252" }}>
              {" "}
              With Business Transfers:
              <span className="fw-normal privacy-title3" style={{ color: " #6b6b6b" }}>
                {" "}
                In the event of a merger, acquisition, or sale of our business,
                your personal information may be transferred as part of the
                transaction.
              </span>
            </h6>
            <h6 className="privacy-title2 fw-semibold" style={{ color: " #525252" }}>
              {" "}
              Security of Your Information:
              <span className="fw-normal privacy-title3" style={{ color: " #6b6b6b" }}>
                {" "}
                We take reasonable steps to protect your personal information
                from unauthorized access, use, or disclosure. However, no method
                of transmission over the internet or electronic storage is 100%
                secure, and we cannot guarantee absolute security.
              </span>
            </h6>
            <h6 className="privacy-title2 fw-semibold" style={{ color: " #525252" }}>
              {" "}
              Cookies and Tracking Technologies:
              <span className="fw-normal privacy-title3" style={{ color: " #6b6b6b" }}>
                {" "}
                We use cookies and similar tracking technologies to improve the
                functionality of our website and to analyze user behavior. You
                can manage your cookie preferences through your browser
                settings.
              </span>
            </h6>
            <h6 className="privacy-title2 fw-semibold" style={{ color: " #525252" }}>
              {" "}
              Third-Party Links:
              <span className="fw-normal privacy-title3" style={{ color: " #6b6b6b" }}>
                {" "}
                Our website may contain links to third-party websites that are
                not operated by us. We are not responsible for the privacy
                practices of these external sites. We encourage you to review
                the privacy policies of those sites before providing any
                personal information.
              </span>
            </h6>
            <h6 className="privacy-title2 fw-semibold" style={{ color: " #525252" }}>
              {" "}
              Age Restriction:
              <span className="fw-normal privacy-title3" style={{ color: " #6b6b6b" }}>
                {" "}
                To ensure a safe and legally compliant experience, our platform
                has an age restriction for delivery partners. The following
                guidelines apply:
              </span>
            </h6>
            <h6 className="privacy-title2 fw-semibold" style={{ color: " #525252" }}>
              {" "}
              Minimum Age Requirement:
              <span className="fw-normal privacy-title3" style={{ color: " #6b6b6b" }}>
                {" "}
                You must be at least 18 years of age to register as a delivery
                partner on our platform. This is because delivery work involves
                legal contracts, financial transactions, and other
                responsibilities that require you to be legally considered an
                adult.
              </span>
            </h6>
            <h6 className="privacy-title2 fw-semibold" style={{ color: " #525252" }}>
              {" "}
              Proof of Age:
              <span className="fw-normal privacy-title3" style={{ color: " #6b6b6b" }}>
                {" "}
                During the registration process, we may ask for proof of your
                age, such as a valid government- issued ID or another form of
                identification to verify your eligibility.
              </span>
            </h6>
            <h6 className="privacy-title2 fw-semibold" style={{ color: " #525252" }}>
              {" "}
              Legal Compliance:
              <span className="fw-normal privacy-title3" style={{ color: " #6b6b6b" }}>
                {" "}
                We comply with local, state, and national regulations regarding
                the minimum age for employment and contracting. If you do not
                meet the age requirement, you will not be able to use our
                platform as a delivery partner.
              </span>
            </h6>
            <h6 className="privacy-title2 fw-semibold" style={{ color: " #525252" }}>
              {" "}
              Marketing:
              <span className="fw-normal privacy-title3" style={{ color: " #6b6b6b" }}>
                {" "}
                We may use your personal data to contact you with email or SMS
                newsletters, marketing or promotional materials and other
                information that may be of interest to you. Unless you opt out
                of receiving any, or all, of these communications from us by
                emailing us using the information noted at the foot of this
                document, which you can do so at any time. If you do not wish to
                receive such communications, please let us know in writing by
                sending an email to .........
              </span>
            </h6>
            <h6 className="privacy-title" style={{ color: " #525252" }}>
              {" "}
              Customer Support and Communication:{" "}
            </h6>
            <p className="fw-normal privacy-title3" style={{ color: " #525252" }}>
              Personal contact details are processed to facilitate communication
              between delivery partners, customers, and the platform, such as
              providing updates on delivery status or resolving issues.
            </p>
            <p className="fw-normal privacy-title3" style={{ color: " #6b6b6b" }}>
              We use data to handle customer inquiries or complaints related to
              delivery experiences.
            </p>
            <h6 className="privacy-title" style={{ color: " #525252" }}>
              {" "}
              Use of Cookies:{" "}
            </h6>
            <p className="fw-normal privacy-title3" style={{ color: " #525252" }}>
              Packky (powered by Chaafo) uses cookies and similar tracking technologies to enhance
              your experience on our platform, improve functionality, and
              analyze website usage. By accessing or using the Packky (powered by Chaafo) platform,
              you consent to the use of cookies as described in this policy.
              Packky (powered by Chaafo) may update this
              <span className="fw-bold"> Cookie Policy</span> from time to time
              to reflect changes in our practices or legal requirements. We will
              notify you of any significant changes and encourage you to review
              this policy periodically to stay informed about how we use
              cookies.
            </p>
          </div>
        </section>
      </div>
    </>
  );
};

export default PrivacyPolicy;
